import { editSystemFields, fetchSystemFields } from '../routines';
import { ID_LEVEL_MAP } from '../../common/constants/CommonConstants';

const initialState = {
  isLoading: false,
  error: false,
  fields: {
    organization: {},
    account: {},
    contact: {},
    pipeline: {},
  },
};

const systemFieldsReducer = (state = initialState, action) => {
  switch (action.type) {
    case editSystemFields.TRIGGER:
    case fetchSystemFields.TRIGGER: {
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    }

    case fetchSystemFields.SUCCESS: {
      const systemFields = action.payload.response.data;
      return {
        ...state,
        isLoading: false,
        fields: systemFields,
      };
    }

    case fetchSystemFields.FAILURE: {
      const error = action.payload;

      return {
        ...state,
        isLoading: false,
        error: {
          error,
        },
      };
    }

    case editSystemFields.SUCCESS: {
      const systemField = { ...action.payload.systemField };
      const prevState = { ...state };
      const level = ID_LEVEL_MAP[systemField.level];
      if (!prevState.fields[level]) {
        return {
          ...prevState,
          isLoading: false,
        };
      }
      const newState = {
        ...prevState,
        fields: {
          ...prevState.fields,
          [level]: {
            ...prevState.fields[level],
            [systemField.name]: {
              ...systemField,
            },
          },
        },
      };
      return {
        ...newState,
        isLoading: false,
      };
    }

    case editSystemFields.FAILURE: {
      const error = action.payload.FAILURE;

      return {
        ...state,
        isLoading: false,
        error: {
          error,
        },
      };
    }

    default: {
      return state;
    }
  }
};

export default systemFieldsReducer;
